import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

//

function _getInitials(names) {
  return names
    .map((name) => name?.[0] || '')
    .join('')
    .trim();
}

// Render
// --------

function StudentBadge({ colorIndex = 0, firstName, lastName, newProfile = false, small = false }) {
  return (
    <div
      className={classnames(`student-badge student-badge--color${colorIndex % 6}`, {
        'student-badge--new-profile': newProfile,
        'student-badge--small': small,
      })}
    >
      {!newProfile && _getInitials([firstName, lastName])}
    </div>
  );
}

StudentBadge.propTypes = {
  colorIndex: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  newProfile: PropTypes.bool,
  small: PropTypes.bool,
};

// Exports
// -------

export default StudentBadge;
